/**
 * @generated SignedSource<<7d8c4f54821741bad2785f7d26593eb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ValidateContactsFieldEnum = "email" | "id";
export type Contacts_Validate_Query$variables = {
  caseInsensitive?: boolean | null | undefined;
  field: ValidateContactsFieldEnum;
  inputBoolean?: boolean | null | undefined;
  inputNumberArray?: ReadonlyArray<number> | null | undefined;
  inputStringArray?: ReadonlyArray<string> | null | undefined;
};
export type Contacts_Validate_Query$data = {
  readonly validateContacts: ReadonlyArray<{
    readonly contact: {
      readonly company: string | null | undefined;
      readonly country: string | null | undefined;
      readonly email: string;
      readonly firstname: string | null | undefined;
      readonly id: string;
      readonly lastname: string | null | undefined;
    } | null | undefined;
    readonly exists: boolean | null | undefined;
    readonly id: string | null | undefined;
    readonly inputNumber: number | null | undefined;
    readonly inputString: string | null | undefined;
  } | null | undefined> | null | undefined;
};
export type Contacts_Validate_Query = {
  response: Contacts_Validate_Query$data;
  variables: Contacts_Validate_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "caseInsensitive"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "field"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inputBoolean"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inputNumberArray"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inputStringArray"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "caseInsensitive",
        "variableName": "caseInsensitive"
      },
      {
        "kind": "Variable",
        "name": "field",
        "variableName": "field"
      },
      {
        "kind": "Variable",
        "name": "inputBoolean",
        "variableName": "inputBoolean"
      },
      {
        "kind": "Variable",
        "name": "inputNumberArray",
        "variableName": "inputNumberArray"
      },
      {
        "kind": "Variable",
        "name": "inputStringArray",
        "variableName": "inputStringArray"
      }
    ],
    "concreteType": "ValidateContacts",
    "kind": "LinkedField",
    "name": "validateContacts",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "exists",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inputString",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inputNumber",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Contact",
        "kind": "LinkedField",
        "name": "contact",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastname",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "company",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "country",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Contacts_Validate_Query",
    "selections": (v6/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "Contacts_Validate_Query",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "0e551b2a17e067828e0e674e48499893",
    "id": null,
    "metadata": {},
    "name": "Contacts_Validate_Query",
    "operationKind": "query",
    "text": "query Contacts_Validate_Query(\n  $field: ValidateContactsFieldEnum!\n  $inputNumberArray: [Int!]\n  $inputStringArray: [String!]\n  $inputBoolean: Boolean\n  $caseInsensitive: Boolean\n) {\n  validateContacts(field: $field, inputNumberArray: $inputNumberArray, inputStringArray: $inputStringArray, inputBoolean: $inputBoolean, caseInsensitive: $caseInsensitive) {\n    id\n    exists\n    inputString\n    inputNumber\n    contact {\n      id\n      firstname\n      lastname\n      email\n      company\n      country\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "45289862a50b63d03a0fe53e3c866332";

export default node;
